// Configuration des endpoints API
export const API_ENDPOINTS = {
  // Relevés d'heures
  RELEVE_HEURES: {
    BASE: '/releve-heures',
    GET_ALL: '/releve-heures',
    GET_BY_CLIENT: '/releve-heures/client',
    GET_BY_FREELANCE: '/releve-heures/freelance',
    GET_MOTIF_ABSENCE: '/releve-heures/motif',
    CREATE: '/releve-heures',
    UPDATE: (id) => `/releve-heures/${id}`,
    DELETE: (id) => `/releve-heures/${id}`
  },

  // Authentification
  AUTH: {
    LOGIN: '/auth/freelance/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh'
  },

  // Utilisateurs
  USER: {
    PROFILE: '/user/profile',
    ACTIVE: '/user/active'
  },

  // Clients
  CLIENT: {
    BASE: '/client',
    FREELANCE_COUNT: '/client/freelance-count',
    BY_ID: (id) => `/client/${id}`
  },

  // Factures
  FACTURE: {
    BASE: '/facture',
    FREELANCE: '/facture/freelance',
    FREELANCE_TO_AGENCY: '/facture/freelance-to-agency',
    CA_MOIS: '/facture/CA-mois',
    COUNT_NON_SOLDEE: '/facture/freelance/countNonSoldee'
  },

  // Commandes
  ORDER: {
    BASE: '/order',
    FREELANCE: '/order/freelance',
    COUNT: '/order/freelance/count'
  },

  // Tâches
  TASK: {
    BASE: '/task',
    TODO_COUNT: '/task/todo-count'
  },

  // Nouvelles tâches
  NEWTASK: {
    BASE: '/newtask',
    FIND_BY_DATE: '/newtask/find-by-date'
  },

  // Candidats
  TEMPWORKER_CANDIDATE: {
    BASE: '/tempworker-candidate',
    FREELANCE_COUNT: '/tempworker-candidate/freelance/tempworker-count'
  },

  // Contrats PLD
  PLD_CONTRACT: {
    BASE: '/pld-contract',
    ACTIVE_MISSIONS: '/pld-contract/active-missions',
    TAUX_CONVERSION: '/pld-contract/taux-conversion'
  },

  // Entretiens
  ENTRETIEN: {
    BASE: '/entretien',
    CREATE: '/entretien'
  },

  // Devis
  QUOTATION: {
    BASE: '/quotation',
    BY_CLIENT: (clientId) => `/quotation/client/${clientId}`
  }
};

// Configuration des statuts pour les relevés d'heures
export const RELEVE_HEURES_STATUS = {
  A_SAISIR: 'a_saisir',
  PENDING: 'pending',
  A_VALIDER: 'a_valider',
  TO_INTEGRATE: 'to_integrate',
  INTEGRATED: 'integrated',
  BLOCKED: 'blocked',
  CANCELED: 'canceled'
};

// Configuration des statuts avec leurs labels et couleurs
export const STATUS_CONFIG = {
  [RELEVE_HEURES_STATUS.A_SAISIR]: {
    label: 'À saisir',
    color: 'orange',
    bgClass: 'bg-orange-100',
    textClass: 'text-orange-800',
    icon: 'AlertCircle'
  },
  [RELEVE_HEURES_STATUS.PENDING]: {
    label: 'En attente',
    color: 'yellow',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-800',
    icon: 'Clock'
  },
  [RELEVE_HEURES_STATUS.A_VALIDER]: {
    label: 'À valider',
    color: 'blue',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-800',
    icon: 'Eye'
  },
  [RELEVE_HEURES_STATUS.TO_INTEGRATE]: {
    label: 'À intégrer',
    color: 'purple',
    bgClass: 'bg-purple-100',
    textClass: 'text-purple-800',
    icon: 'Send'
  },
  [RELEVE_HEURES_STATUS.INTEGRATED]: {
    label: 'Intégré',
    color: 'green',
    bgClass: 'bg-green-100',
    textClass: 'text-green-800',
    icon: 'CheckCircle2'
  },
  [RELEVE_HEURES_STATUS.BLOCKED]: {
    label: 'Bloqué',
    color: 'red',
    bgClass: 'bg-red-100',
    textClass: 'text-red-800',
    icon: 'XCircle'
  },
  [RELEVE_HEURES_STATUS.CANCELED]: {
    label: 'Annulé',
    color: 'gray',
    bgClass: 'bg-gray-100',
    textClass: 'text-gray-800',
    icon: 'XCircle'
  }
};

// Configuration des types d'heures
export const TYPES_HEURES = [
  "Heures diverses",
  "Heures d'entretien annuel",
  "Heures de formation",
  "Heures de pause",
  "Heures de réunion",
  "Heures de route",
  "Heures visite médicale"
];

// Configuration des types de primes
export const TYPES_PRIMES = [
  "Prime Ségur 1",
  "Prime Ségur 2",
  "Prime 13e mois",
  "Prime d'assiduité",
  "Prime d'ancienneté",
  "Prime d'astreinte",
  "Prime d'encadrement",
  "Prime de fonction",
  "Prime de salissure",
  "Prime de pénibilité",
  "Prime de performance",
  "Prime de productivité",
  "Prime de remplacement",
  "Prime de responsabilité",
  "Prime de rendement",
  "Prime de caissier(e)",
  "Prime de déménagement",
  "Prime de fin d'année",
  "Prime de froid",
  "Prime de jours fériés",
  "Prime de mariage",
  "Prime de maîtrise",
  "Prime de nuit",
  "Prime de panier",
  "Prime de ponctualité",
  "Prime de prestation",
  "Prime de résultats",
  "Prime de secrétariat",
  "Prime de sujétion",
  "Prime de vacances",
  "Prime exceptionnelle",
  "Prime Macron / PPV",
  "Prime de non-concurrence",
  "Prime de départ en retraite",
  "Prime de polyvalence",
  "Prime de danger"
];

// Configuration des types d'indemnités
export const TYPES_INDEMNITES = [
  "Indemnité de déplacement",
  "Indemnité de départ volontaire",
  "Indemnité de formation",
  "Indemnité de fonction",
  "Indemnité de logement",
  "Indemnité de non-concurrence",
  "Indemnité de sujétion",
  "Indemnité de trajet",
  "Indemnité de transport",
  "Indemnité de repas",
  "Indemnité de panier",
  "Indemnité kilométrique"
];

export default API_ENDPOINTS;
